<template>
  <a-drawer
    title="设置名校毕业"
    :width="400"
    :visible="open"
    :mask-closable="false"
    @close="handleCancel"
  >
    <a-form :form="form" layout="vertical">
      <a-form-item label="医师姓名">
        <span>{{ doctorInfo.name || '' }}</span>
      </a-form-item>
      <a-form-item
        label="毕业院校"
        :validateStatus="validateStatus"
        :help="helpMsg"
        required
      >
        <a-select
          v-model="selectedSchoolId"
          placeholder="请选择毕业院校"
          style="width: 100%"
          @change="handleSchoolChange"
        >
          <a-select-option value="">请选择</a-select-option>
          <a-select-option
            v-for="school in schoolList"
            :key="school.id"
            :value="school.id"
          >
            {{ school.schoolName }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <div style="position: absolute; bottom: 20px; right: 20px; width: calc(100% - 40px); text-align: right;">
      <a-button
        style="margin-right: 8px"
        @click="handleCancel"
      >
        取消
      </a-button>
      <a-button
        type="primary"
        :loading="loading"
        @click="handleSubmit"
      >
        确认
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getFamousSchoolList, setDoctorFamousSchool } from '@/api/doctor/doctor'

export default {
  name: 'CreateFamousSchoolForm',
  data() {
    return {
      open: false,
      loading: false,
      form: this.$form.createForm(this),
      doctorInfo: {}, // 医师信息
      schoolList: [], // 名校列表
      selectedSchoolId: '', // 选中的学校ID
      validateStatus: 'success',
      helpMsg: ''
    }
  },
  created() {
    // 初始化加载名校列表
    this.loadSchoolList()
  },
  methods: {
    /** 加载名校列表 */
    loadSchoolList() {
      getFamousSchoolList()
        .then((res) => {
          if (res.success) {
            console.log('名校列表数据：', res.data)
            this.schoolList = res.data || []
          } else {
            this.$message.error('加载名校列表失败: ' + res.message)
          }
        })
        .catch(() => {
          this.$message.error('加载名校列表异常，请稍后重试')
        })
    },

    /** 打开抽屉 */
    handleFamousSchool(record) {
      // 初始化数据
      this.doctorInfo = { ...record }
      this.selectedSchoolId = record.prestigiousSchoolId || ''
      this.validateStatus = 'success'
      this.helpMsg = ''
      this.open = true
    },

    /** 关闭抽屉 */
    handleCancel() {
      this.open = false
      this.doctorInfo = {}
      this.selectedSchoolId = ''
      this.validateStatus = 'success'
      this.helpMsg = ''
    },

    /** 学校选择变化校验 */
    handleSchoolChange() {
      this.validateForm()
    },

    /** 表单校验 */
    validateForm() {
      if (!this.selectedSchoolId) {
        this.validateStatus = 'error'
        this.helpMsg = '请选择毕业院校'
        return false
      } else {
        this.validateStatus = 'success'
        this.helpMsg = ''
        return true
      }
    },

    /** 提交保存 */
    handleSubmit() {
      // 表单校验
      if (!this.validateForm()) {
        this.$message.error('请选择毕业院校')
        return
      }

      this.loading = true
      // 调用接口保存
      setDoctorFamousSchool(this.doctorInfo.id, this.selectedSchoolId)
        .then((res) => {
          if (res.success) {
            this.$message.success('名校毕业设置成功')
            this.open = false
            // 通知父组件刷新列表
            this.$emit('ok')
          } else {
            this.$message.error(`名校毕业设置失败: ${res.message}`)
          }
        })
        .catch(() => {
          this.$message.error('名校毕业设置异常，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>